module.exports = __webpack_public_path__ + "img/icon-back-to-index.541ac05e.png";